import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import PropertyData from '../../DashboardPendings/PendingEvents/PropertyData';
import PerformanceCard from '../PerformanceCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import ConsultationsIndicator from '../ConsultationsIndicator';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import styles from './consultedEntities.module.scss';
import { TRACK_ELEMENT } from '../../constants/track';

const DEFAULT_FORMAT = 'es-AR';

function ConsultedEntities({
  title,
  stateKey,
  stateSubkey,
  entityType = 'property',
  fetchCallback = () => {},
  openTableCallback = null,
  trackCallback = null,
  emptyStateChildren = null,
  ...rest
}) {
  const dispatch = useDispatch();
  const dashboardState = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const source = dashboardState[stateKey];
  const list = source[stateSubkey];
  const isDevelopment = entityType === 'development';

  useFetchOnViewport(
    (query) => {
      fetchCallback(query);
    },
    [],
    { hasFetched: source.hasFetched }
  );

  const safetyTrackClick = (element) => {
    if (trackCallback) {
      trackCallback(element);
    }
  };

  const openQD = (id) =>
    dispatch(
      showQuickDisplay({
        id,
        development: isDevelopment,
      })
    );

  return (
    <PerformanceCard ref={ref} loading={source.loading || isStale} {...rest}>
      <PerformanceCard.Header handleClickTableIcon={openTableCallback}>
        {title}
      </PerformanceCard.Header>

      <PerformanceCard.Content>
        {list.length === 0 && emptyStateChildren}

        {list.map((entity, index) => (
          <Box key={entity.id} className={styles.consultedEntitiesRow}>
            <Box
              className={styles.consultedEntitiesInnerRow}
              onClick={() => {
                openQD(entity.id);
                safetyTrackClick(TRACK_ELEMENT.ROW);
              }}
            >
              <PropertyData
                picture={entity.image_url}
                location={entity.type}
                address={entity.address}
                entityType={entityType}
                onClick={(event) => {
                  event.stopPropagation();
                  openQD(entity.id);
                  safetyTrackClick(TRACK_ELEMENT.PROPERTY_ADDRESS);
                }}
              />

              <Box className={styles.entitySpecificData}>
                {isDevelopment ? (
                  <Text className={styles.entitySpecificDataTitle}>
                    {entity.construction_status}
                  </Text>
                ) : (
                  <>
                    <Text className={styles.entitySpecificDataTitle}>{`${
                      entity.currency
                    } ${Intl.NumberFormat(DEFAULT_FORMAT).format(
                      entity.price
                    )}`}</Text>
                    <Text className={styles.entitySpecificDataSubtitle}>
                      {entity.operation}
                    </Text>
                  </>
                )}
              </Box>

              <ConsultationsIndicator consultations={entity.inquiry} />
            </Box>

            {index !== list.length - 1 && <Box className={styles.separator} />}
          </Box>
        ))}
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}

export default ConsultedEntities;
